<template >
  <div id="user-info-card">
    <div class="user-info-card-info">
      <div class="info-section">
        <div class="section-header">
          <h2>Subscription</h2>
          <div class="sub-info-section-btn-group">
            <TerminalBasicButton
              buttonText="Change Plan"
              color="unibit-yellow"
              v-on:terminalBasicButtonClicked="changePlan"
            ></TerminalBasicButton>

            <TerminalBasicButton
              v-if="plan !== 'free' && invoice.cancelAtPeriodEnd"
              id="activate"
              data-toggle="modal"
              data-target="#SubscriptionActivate"
              buttonText="Reactivate Subscription"
              color="unibit-yellow"
            ></TerminalBasicButton>
          </div>
        </div>
        <div class="sub-info-section">
          <p>Plan: {{plan}} {{amountPaid}}/mo</p>
        </div>
      </div>
    </div>

    <Modal id="SubscriptionCancel" :header="false">
      <div slot="body">
        <p class="cancel-info">Your {{plan}} Plan cancellation will take place on {{enddate}}.</p>
        <p class="cancel-info">You can reactivate it at anytime.</p>

        <div style="margin-top:3rem; text-align:center" class="download-button-group">
          <TerminalBasicButton
            data-dismiss="modal"
            buttonText="Confirm"
            v-on:terminalBasicButtonClicked="cancelPlan"
          ></TerminalBasicButton>
          <p class="footer-message" data-dismiss="modal">Give it a second thought</p>
        </div>
      </div>
    </Modal>

    <Modal id="SubscriptionActivate" :header="false">
      <div slot="body">
        <p
          class="cancel-info"
        >Your {{plan}} Plan will activate immediately. Your next billing invoice will take place at {{enddate}}.</p>
        <div style="margin-top:3rem; text-align:center" class="download-button-group">
          <TerminalBasicButton
            data-dismiss="modal"
            buttonText="Confirm"
            v-on:terminalBasicButtonClicked="activatePlan"
          ></TerminalBasicButton>
        </div>
      </div>
    </Modal>

    <div class="info-section" style="padding: 0 1rem">
      <div class="section-header">
        <h2>Usage</h2>
      </div>
      <div class="info-update">
        <p>Credits:</p>
        <div v-if="!updating" class="my-progress-bar">
          <ProcessBar :total="totalCredits" :available="availableCredits"></ProcessBar>
        </div>
      </div>
      <div class="info-update-credits">
        <span>{{insertCommaInNumber(availableCredits) + "/" + insertCommaInNumber(totalCredits)}}</span>
        <span @click="refreshUsage" class="refresh">
          <img class="refresh-img" src="../../assets/imgs/ic-refresh.png" alt="refresh icon" />
        </span>
      </div>
      <div style="margin-top:2px">
        <div>
          <p>Overage: {{overage}}</p>
          <p>Estimated overage fee: ${{overageFee}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TerminalBasicButton from "@/components/base/terminal-basic-button";
import ProcessBar from "@/components/bar/process-bar";
import Modal from "@/components/base/modal";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    TerminalBasicButton,
    ProcessBar,
    Modal
  },

  data() {
    return {
      updating: false
    };
  },

  computed: {
    amountPaid() {
      if (!this.invoice) return " ";
      let price = "";
      switch (this.plan.toLowerCase()) {
        case "free":
          price = "$0.00";
          break;
        case "starter":
          price = "$199.00";
          break;
        case "pro":
          price = "$299.00";
          break;
        default:
          price = "TBD";
          break;
      }
      return price;
    },

    overageFee() {
      return (this.overage / 100000).toFixed(2);
    },

    totalCredits() {
      let total = 0;
      const base = 5 * 10 ** 4;
      switch (this.plan.toLowerCase()) {
        case "free":
          total = base;
          break;
        case "starter":
          total = 10 ** 7;
          break;
        case "pro":
          total = 3 * 10 ** 7;
          break;
        default:
          total = base;
          break;
      }
      return total;
    },

    email() {
      return this.getWindowLocalStorage("email");
    },

    enddate() {
      const time = this.subPeriodEnddate * 1000;
      return new Date(time).toLocaleDateString("en-US");
    },

    ...mapState({
      plan: state => state.UserService.userPlan,
      overage: state => state.UserService.overageCredits,
      availableCredits: state => state.UserService.availableCredits,
      invoice: state => state.UserService.billingInvoice,
      subPeriodEnddate: state => state.UserService.subPeriodEnddate
    })
  },
  methods: {
    changePlan() {
      this.$router.replace("/upgrade");
    },

    cancelPlan() {
      this.$store
        .dispatch("cancelSubscription", { email: this.email })
        .then(res => {
          console.log("cancel plan suceessfully");
          this.$store.commit("changeSubscriptionStatus", true);
          this.$store.dispatch("notify", {
            info: "Cancel Plan Suceessfully",
            type: "success"
          });
        })
        .catch(err => {
          console.log("cancelPlan() error is: ", err.response.data);
          const info = err.response.data.message;
          this.$store.dispatch("notify", { info, type: "error" });
        });
    },

    activatePlan() {
      this.$store
        .dispatch("activateSubscription", { email: this.email })
        .then(res => {
          console.log("activate plan suceessfully");
          this.$store.commit("changeSubscriptionStatus", false);
          this.$store.dispatch("notify", {
            info: "Reactivate Plan Suceessfully",
            type: "success"
          });
        })
        .catch(err => {
          console.log("activatePlan() error is: ", err.response.data);
          const info = err.response.data.message;
          this.$store.dispatch("notify", { info, type: "error" });
        });
    },

    refreshUsage() {
      const token = this.getWindowLocalStorage("token");
      this.$store
        .dispatch("getProfile", { token })
        .then(response => response.json())
        .then(res => {
          this.$store.commit("saveUserInfoInState", res);
          this.updating = true;
          setTimeout(() => (this.updating = false), 0);
          this.$store.dispatch("notify", {
            info: "Update Credits Usage Suceessfully",
            type: "success"
          });
        });
    }
  }
};
</script>

<style lang="css" scoped>
* {
  font-family: Raleway;
  font-size: 0.875rem;
  /* font-weight: bold; */
  color: #656666;
  letter-spacing: 0.56px;
}

#user-info-card {
  background-color: white;
  height: 100%;
  overflow: auto;
}

#cancel {
  margin-left: 1rem;
}

.cancel-info {
  letter-spacing: 0.59px;
  color: #ffffff;
  text-align: center;
}

.footer-message {
  margin-top: 1rem;
  cursor: pointer;
}

.footer-message:hover {
  text-decoration: underline;
}

.user-info-card-info {
  padding: 1rem;
}

.info-section {
  margin-bottom: 1rem;
}

.info-section h2 {
  font-weight: bold;
  line-height: 2rem;
  margin: 0px;
  font-size: 1rem;
}

.sub-info-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sub-info-section-btn-group > * {
  display: inline-block;
}

.update-input {
  border: 0;
  outline: 0;
  background: transparent;
}

.info-section > div {
  background-color: white;
  padding: 0.5rem 1rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0 !important;
  margin-bottom: 2px;
  border-bottom: solid 0.4px rgba(151, 151, 151, 0.5);
}

.info-update {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.info-update > span {
  margin: 0 1rem;
}

.info-update > span.refresh {
  margin: 0;
}

.refresh:hover {
  cursor: pointer;
  rotate: 45;
}

img.refresh-img {
  width: 1rem;
  height: 1rem;
  margin: 0 1rem;
  -webkit-transition: -webkit-transform 0.8s ease-in-out;
  transition: transform 0.8s ease-in-out;
}

img.refresh-img:hover {
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
}

.my-progress-bar {
  width: 12.5rem;
  margin-left: 2rem;
}

@media only screen and (min-width: 768px) {
  .info-section > div {
    padding: 0.5rem 1rem;
  }

  .info-update {
    justify-content: flex-start;
  }

  .my-progress-bar {
    width: 20rem;
  }
}

@media only screen and (min-width: 992px) {
  * {
    font-size: 1rem;
  }

  #user-info-card {
    padding: 3rem 2.5rem;
  }

  /* .info-update {
    justify-content: space-between;
  } */

  .my-progress-bar {
    margin-left: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/sub-info-card.vue